<template>
  <div class="wlx-system-manager-wrapper">
    <div class="system-manager-head clearfix">
      <div class="school-logo-con fl">
        <img :src="schoolLogo" alt class="logo-img" />
      </div>
      <div class="fl system-manager-head-title">后台管理系统</div>
      <div class="fr system-stu-info-con clearfix">
        <router-link class="fl enter-to-back-home" :to="{name:'managerIndex'}"  style="margin-right:10px">
          <i class="wl-icon-jiugongge" style="margin-right:10px"></i>
          <span>后台首页</span>
        </router-link>
        <router-link class="fl enter-to-back-home" :to="{name:'xHome'}" target="_blank">
          <i class="wl-icon-shouye2"></i>
          <span>前台首页</span>
        </router-link>
        <div class="head-user-logo-con fl">
          <img :src="userLogo" alt />
        </div>
        <div class="fl head-user-info">
          <span>{{userInfo.userName}}</span>
        </div>
        <div class="fr get-out-sys" @click="outLogin">
          <i class="wl-icon-dianyuan"></i>
        </div>
      </div>
    </div>
    <div class="system-manager-content clearfix">
      <div class="system-menu-con fl">
        <!-- 系统管理员 -->
        <ul>
          <li v-for="(item,index) in systemMenu" :key="index">
            <router-link :to="{name:item.name}" class="clearfix">
              <i :class="item.icon"></i>
              {{item.title}}
              <i class="wl-icon-xiangyou fr"></i>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="system-manager-con-main fr">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { MU_UPATE_AUTH } from "store/index";
export default {
  data() {
    return {
      schoolLogo: require("assets/images/clpp-logo.png"),
      userLogo: require("assets/images/default_avatar3.png"),
      systemMenu: [
        {
          title: "学生成绩管理",
          name: "resultsManager",
          icon: "wl-icon-shenbao"
        },
        {
          title: "证书管理",
          name: "certificateManager",
          icon: "wl-icon-shenbao"
        },
        {
          title: "证书类型设置",
          name: "certificateTypeManager",
          icon: "wl-icon-shenbao"
        }
      ]
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.auth;
    }
  },
  created() {
    var that = this;
    if (localStorage["userId"] !== undefined) {
      that.$store.dispatch(MU_UPATE_AUTH).then(rt => {});
    }
  },
  methods: {
    backToHome() {
      this.$router.push({
        name: "xHome"
      });
    },
    outLogin() {
      var that = this;
      this.$http.post("/api/XOrg/XLogin/outLogin").then(function(rst) {
        if (rst.code > 0) {
          that.$store.commit(MU_UPATE_AUTH, null);
          that.$router.push({ name: "xHome" });
        } else {
          that.$message.warning(rst.msg);
        }
      });
    }
  }
};
</script>

<style lang="scss">
.wlx-system-manager-wrapper {
  height: 100%;
  .system-manager-head {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 60px;
    z-index: 1000;
    background: #2d82ff;
    .school-logo-con {
    }
    .logo-img {
      margin: 11px 0 0 42px;
      height: 38px;
    }
    .system-manager-head-title {
      margin: 11px 0 0 20px;
      padding-left: 20px;
      color: #fff;
      font-size: 16px;
      height: 38px;
      border-left: 1px solid #fff;
      line-height: 38px;
    }
    .system-stu-info-con {
      color: #fff;
      font-size: 14px;
    }
    .head-user-logo-con {
      margin: 8px 21px 0 30px;
      padding-left: 29px;
      border-left: 1px solid #fff;
      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
    }
    .a-link-data-static {
      margin: 16px 20px 0 0;
      padding: 4px 12px;
      color: #fff;
      background: #1526a9;
      border-radius: 6px;
      font-size: 16px;
    }
    .enter-to-back-home {
      margin-top: 20px;
      cursor: pointer;
      .wl-icon-shouye2 {
        font-size: 22px;
        vertical-align: -4px;
        margin-right: 6px;
      }
      color: #fff;
    }
    .head-user-info {
      margin-top: 20px;
    }
    .sp-head-line {
      margin: 0 10px;
      font-size: 17px;
      vertical-align: 1px;
    }
    .get-out-sys {
      height: 60px;
      width: 60px;
      text-align: center;
      line-height: 60px;
      font-size: 22px;
      margin-left: 29px;
      border-left: 1px solid #176ae5;
      cursor: pointer;
    }
  }
  .system-manager-content {
    position: fixed;
    top: 60px;
    left: 0;
    width: 100%;
    height: 60px;
    z-index: 1000;
    height: calc(100% - 60px);
  }
  .system-menu-con {
    width: 240px;
    height: 100%;
    background: #2f333e;
    color: #fff;
    font-size: 14px;
    a {
      display: block;
      padding: 0 20px;
      height: 49px;
      line-height: 49px;
      color: #fff;
      font-size: 14px;
      border-left: 3px solid #2f333e;
    }
    i {
      margin-right: 5px;
    }
    .linkActive {
      background: #252933;
      border-left: 3px solid #2d82ff;
      .wl-icon-xiangyou {
        color: #2d82ff;
      }
    }
  }

  .system-manager-con-main {
    width: calc(100% - 240px);
    height: 100%;
    background: #e7ecf4;
    overflow: auto;
  }
}
</style>
